/** Die Eingabe ist keine gültige Dezimalzeichenkette. */
export class MoneyParseError extends Error {
    constructor(message) {
        super(message);
        this.name = 'MoneyParseError';
    }
}
/** Der Betrag hat mehr Nachkommastellen, als der Vorgang zulässt. */
export class MoneyScaleError extends Error {
    constructor(message) {
        super(message);
        this.name = 'MoneyScaleError';
    }
}
/** Die Gewichte einer Verteilung sind unbrauchbar (leer, negativ oder in Summe null). */
export class MoneyAllocationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'MoneyAllocationError';
    }
}
/** Division durch null. */
export class MoneyDivisionError extends Error {
    constructor(message) {
        super(message);
        this.name = 'MoneyDivisionError';
    }
}
//# sourceMappingURL=types.js.map